<ion-footer collapse="fade" slot="end">
  <ion-badge *ngIf="showPointsInd" [color]="'light'" [mode]="'md'"> {{ points }} Points </ion-badge>
  <ion-toolbar class="ion-no-padding">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col *ngIf="usePrevButtonInd" size="2">
          <ion-button class="back-btn" color="light" expand="block" mode="ios" (click)="emitPrev.emit()">
            <fa-icon slot="end" size="sm" [icon]="faArrowLeft"></fa-icon>
          </ion-button>
        </ion-col>
        <ion-col *ngIf="!waitingPhoneVerification" [size]="usePrevButtonInd ? 10 : 12">
          <ion-button color="carouselbutton" expand="block" mode="ios" [disabled]="disableNextButton" (click)="emitNext.emit()">
            <ng-container *ngIf="isProcessing; else default">
              <ion-spinner name="circular" class="ion-margin-end"></ion-spinner>
              Processing...
            </ng-container>
            <ng-template #default>
              <ion-label>{{ label }}</ion-label>
              <fa-icon *ngIf="showIconInd" slot="end" size="sm" [icon]="faArrowRight" class="ion-margin-start"></fa-icon>
            </ng-template>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
